import React, { useState } from "react";
import { OrderDetailsModal } from "../../components/admin/OrderDetailsModal";
import { API_BASE_URL } from "../../API/endpoint";

export const OrdersTab = ({ orders, onUpdateStatus, onDelete, onViewDetails, getThumbnailUrl }) => {
  const [viewingOrder, setViewingOrder] = useState(null);
  const [viewingImage, setViewingImage] = useState(null);

  const handleViewDetails = async (orderId) => {
    const orderDetails = await onViewDetails(orderId);
    if (orderDetails) {
      setViewingOrder(orderDetails);
    }
  };

  return (
    <div className="admin-section ">
      <h2>Gestion des Commandes</h2>
      <div className="table-container">
        <div className="product-admin-table">
          <div className="product-header">
            <div>ID</div>
            <div>Client</div>
            <div>Total(€)</div>
            <div>Statut</div>
            <div>N°_de_Paiement</div>
            <div>Date</div>
            <div>Actions</div>
          </div>
          {[...orders]
            .sort((a, b) => b.id - a.id)
            .map((order) => (
              <div className="product-row" key={order.id}>
                <div className="product-cell">{order.id}</div>
                <div className="product-cell cell-name">
                  {order.payerFirstName && order.payerLastName
                    ? `${order.payerFirstName} ${order.payerLastName}`
                    : order.utilisateur
                    ? `${order.utilisateur.prenom} ${order.utilisateur.nom}`
                    : "N/A"}
                </div>
                <div className="product-cell">{parseFloat(order.total).toFixed(2)} €</div>
                <div className="product-cell">
                  <select
                    className={`status-select status-${order.status.trim().toLowerCase().replace(/\s+/g, '-').normalize('NFD').replace(/[\u0300-\u036f]/g, '')}`}
                    value={order.status}
                    onChange={(e) => onUpdateStatus(order.id, e.target.value)}
                  >
                    <option value="En attente">En attente</option>
                    <option value="En cours">En cours</option>
                    <option value="Expédiée">Expédiée</option>
                    <option value="Livrée">Livrée</option>
                    <option value="Annulée">Annulée</option>
                  </select>
                </div>
                <div className="product-cell">{order.paymentId}</div>
                <div className="product-cell">{new Date(order.createdAt).toLocaleDateString()}</div>
                <div className="product-cell admin-actions">
                  <button
                    className="btn-edit"
                    onClick={() => handleViewDetails(order.id)}
                  >
                    <i className="bi bi-eye"></i>
                  </button>
                  <button
                    className="btn-delete"
                    onClick={() => onDelete(order.id)}
                  >
                    <i className="bi bi-trash"></i>
                  </button>
                </div>
              </div>
            ))}
        </div>
      </div>

      {viewingOrder && (
        <OrderDetailsModal
          order={viewingOrder}
          getThumbnailUrl={getThumbnailUrl}
          onClose={() => setViewingOrder(null)}
          setViewingImage={setViewingImage}
        />
      )}

      {viewingImage && (
        <div
          className="modal-overlay"
          onClick={() => setViewingImage(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              maxWidth: "90%",
              maxHeight: "90%",
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "20px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
            }}
          >
            <button
              onClick={() => setViewingImage(null)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "rgba(0, 0, 0, 0.5)",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                fontSize: "24px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              &times;
            </button>
            <img
              src={viewingImage}
              alt="Produit en grand"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                objectFit: "contain",
                display: "block",
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};
